import { SnackbarContent } from 'notistack';
import styled from 'styled-components';
import Container from '../../components/Container';
import Icon from '../../components/Icon';
import Typography from '../../components/Typography/Typography';
export const ToastStyled = styled(SnackbarContent)(({ theme, }) => ({}));
export const ToastWrapper = styled(Container).attrs({
    rounded: true,
    shadow: 'xs',
})(({ theme, variant = 'info', }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
    return ({
        width: '100%',
        display: 'flex',
        padding: 15,
        overflow: 'hidden',
        transform: 'translateX(0)',
        alignItems: 'center',
        gap: 10,
        ...{
            info: {
                backgroundColor: (_b = (_a = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _a === void 0 ? void 0 : _a.blue) === null || _b === void 0 ? void 0 : _b.light,
                [`${ToastIcon}`]: {
                    color: (_d = (_c = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _c === void 0 ? void 0 : _c.blue) === null || _d === void 0 ? void 0 : _d.base,
                },
            },
            success: {
                backgroundColor: (_f = (_e = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _e === void 0 ? void 0 : _e.teal) === null || _f === void 0 ? void 0 : _f.light,
                [`${ToastIcon}`]: {
                    color: (_h = (_g = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _g === void 0 ? void 0 : _g.teal) === null || _h === void 0 ? void 0 : _h.base,
                },
            },
            error: {
                backgroundColor: (_k = (_j = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _j === void 0 ? void 0 : _j.pink) === null || _k === void 0 ? void 0 : _k.light,
                [`${ToastIcon}`]: {
                    color: (_m = (_l = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _l === void 0 ? void 0 : _l.pink) === null || _m === void 0 ? void 0 : _m.dark,
                },
            },
        }[variant],
        '&:before': {
            content: '""',
            display: 'block',
            position: 'absolute',
            width: 4,
            top: 0,
            left: 0,
            bottom: 0,
            ...{
                info: {
                    backgroundColor: (_p = (_o = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _o === void 0 ? void 0 : _o.blue) === null || _p === void 0 ? void 0 : _p.base,
                },
                success: {
                    backgroundColor: (_r = (_q = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _q === void 0 ? void 0 : _q.teal) === null || _r === void 0 ? void 0 : _r.base,
                },
                error: {
                    backgroundColor: (_t = (_s = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _s === void 0 ? void 0 : _s.pink) === null || _t === void 0 ? void 0 : _t.dark,
                },
            }[variant],
        },
        [theme === null || theme === void 0 ? void 0 : theme.breakpoints.not('mobile')]: {
            [`${ToastIcon}`]: {
                svg: {
                // height: 24,
                },
            },
        },
    });
});
export const ToastIcon = styled(Icon)(({ theme, }) => ({}));
export const ToastTypography = styled(Typography)(({ theme, }) => ({}));
//# sourceMappingURL=toast.styles.js.map